import scrollInView, { ScrollInViewBehaviourType, ScrollInViewType } from '../../../common/service/scrollInView';
import { MouseEvent, useCallback } from 'react';
import { routeUtils } from '../../../common/utils/routeUtils';
import { useHistory } from 'react-router-dom';
import customise from '../../constants/customise';
import useStockUrl from './useStockUrl';
import { useTheme } from '@material-ui/core';
import { ISpcTheme } from '../../../common/theme/ISpcTheme';

interface IUseScrollToSection {
  scrollToSection: (name: string, scrollBehaviour?: ScrollInViewBehaviourType) => void;
  scrollToDisclaimer: (e: MouseEvent<HTMLAnchorElement> | MouseEvent<HTMLButtonElement>) => void;
}

export default function useScrollToSection(): IUseScrollToSection {
  const { listUrl } = useStockUrl();
  const history = useHistory();
  const {
    spc: {
      customise: { scrollVehicleStock },
    },
  } = useTheme<ISpcTheme>();

  const scrollToSection = useCallback((name: string, scrollBehaviour?: ScrollInViewBehaviourType) => {
    const selectedSectionElement = document.getElementById(`${customise.DOM_ID_PREFIX}${name}`);
    const disclaimerElement = document.querySelector(`[id*="${'disclaimer'}"]`) as HTMLElement;
    const stockElement = document.querySelector(`[id*="${'stock'}"]`) as HTMLElement;

    const smoothStockScroll =
      name === customise.STOCK_ITEM.name ? ScrollInViewBehaviourType.SMOOTH : ScrollInViewBehaviourType.AUTO;
    if (scrollVehicleStock && name === customise.STOCK_ITEM.name) {
      return routeUtils.pushWithQueryParams(history, listUrl);
    }

    if (selectedSectionElement) {
      scrollInView.scrollInView(selectedSectionElement, ScrollInViewType.TOP, scrollBehaviour ?? smoothStockScroll);
    }

    if (disclaimerElement && !selectedSectionElement) {
      scrollInView.scrollInView(
        disclaimerElement,
        ScrollInViewType.TOP,
        scrollBehaviour ?? ScrollInViewBehaviourType.AUTO,
      );
      stockElement.scrollIntoView();
      return;
    }
  }, []);

  const scrollToDisclaimer = useCallback((e: MouseEvent<HTMLAnchorElement> | MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    scrollToSection(customise.DISCLAIMER, ScrollInViewBehaviourType.SMOOTH);
  }, []);

  return { scrollToSection, scrollToDisclaimer };
}
